import { render, staticRenderFns } from "./CreateModifierGroupModal.vue?vue&type=template&id=d218f21a&scoped=true"
import script from "./CreateModifierGroupModal.vue?vue&type=script&lang=ts"
export * from "./CreateModifierGroupModal.vue?vue&type=script&lang=ts"
import style0 from "./CreateModifierGroupModal.vue?vue&type=style&index=0&id=d218f21a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d218f21a",
  null
  
)

export default component.exports